import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "codeDisplay", "urlLink"]
  static values = { 
    joinUrl: String 
  }

  connect() {
    console.log("Join code controller connected")
  }

  showModal(event) {
    console.log("Show modal clicked")
    const code = event.currentTarget.dataset.joinCodeCodeParam
    console.log("Code:", code)
    
    // Display the code in the modal
    this.codeDisplayTarget.textContent = code
    
    // Set the join URL
    this.urlLinkTarget.href = this.joinUrlValue
    this.urlLinkTarget.textContent = this.joinUrlValue
    
    // Show the modal
    this.modalTarget.style.display = "block"
  }

  hideModal() {
    console.log("Hide modal clicked")
    this.modalTarget.style.display = "none"
  }
}